import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {TheCryptGameAssets} from "./game/TheCryptGameAssets";
import {ITheCryptGameData} from "./game/server/ITheCryptData";
import {TheCryptGameMode} from "./game/server/TheCryptGameMode";
import {TheCryptHelper} from "./game/utils/TheCryptHelper";
import {TheCryptSoundConfig} from "./game/configs/TheCryptSoundConfig";
import {TheCryptSoundManager} from "./game/sound/TheCryptSoundManager";
import {TheCrypt} from "./game/TheCrypt";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {gsap} from "gsap";


export class TheCryptPromoPanelConfig implements PromoPanelGameConfiguration{
    constructor() {
    }



    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "The Crypt",
            hasActionSpin: true,
            mainGame: {
                header: ()=>"xBET",
                options: [
                    {name:"NORMAL", id:0, image:"NORMAL.png"},
                    {name:"BOOSTED_BET" ,id:1, image:"BOOSTED_BET.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: TheCryptGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: ITheCryptGameData, bet: number, prevResponse: ITheCryptGameData):ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }


    private isBigWin(response:ITheCryptGameData): boolean {
        let win = response.totalSpinWinnings;

        if (response.wasFeatureBuy){
            const betPrice = TheCryptHelper.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: ITheCryptGameData, bet: number, prevData: ITheCryptGameData): number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response: ITheCryptGameData): boolean {
        return (response.mode === TheCryptGameMode.NORMAL || response.mode === TheCryptGameMode.NORMAL_AVALANCHE) && response.nextMode === TheCryptGameMode.FREESPIN;
    }

    private getFeatureName(response: ITheCryptGameData): string {
        if (response.mode == TheCryptGameMode.FREESPIN || response.nextMode == TheCryptGameMode.FREESPIN || response.mode == TheCryptGameMode.FREESPIN_AVALANCHE || response.nextMode == TheCryptGameMode.FREESPIN_AVALANCHE){
            return "RESURRECTION SPINS";
        }
        return response.mode;
    }

    private isRoundComplete(response: ITheCryptGameData): boolean {
        return ([TheCryptGameMode.FREESPIN, TheCryptGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: ITheCryptGameData): boolean {
        return ((response.nextMode === TheCryptGameMode.NORMAL) && (response.mode === TheCryptGameMode.FREESPIN || response.mode === TheCryptGameMode.FREESPIN_AVALANCHE));
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            TheCryptSoundManager.playSound(TheCryptSoundConfig.AS_WIN);
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            TheCryptSoundManager.playSound(TheCryptSoundConfig.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data:any):void {
        TheCrypt.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        TheCrypt.model.onGame(<ITheCryptGameData>data);
        TheCrypt.realArea.reInitReels();
        TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
        setTimeout(()=>{
            TheCrypt.gameFlowController.start()
        }, 300);
    }





}